// Where every request in requests.js goes. The app talks to its own host; the
// admin setup page points it at the admin mirror of one organization, so the
// app's setup windows run there unchanged.
let apiBaseUrl = `${location.protocol}//${location.host}`;

export function getApiBaseUrl() {
  return apiBaseUrl;
}

export function setApiBaseUrl(url) {
  apiBaseUrl = url;
}
